import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;

  max-height: 100%;

  overflow: auto;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};

  padding: ${({ theme }) =>
    `${theme.spacing(6)} ${theme.spacing(5)} ${theme.spacing(2)}`};
`;

export const Description = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};

  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  padding: ${({ theme }) => `0 ${theme.spacing(5)}`};

  overflow: auto;
`;

export const ScrollContainer = styled.div`
  // needed for iOS as it would otherwise show a horizontal scrollbar for nothing. this container prevents that.
`;

export const Table = styled.table`
  table-layout: fixed;

  width: ${({ theme }) => `calc(100% + ${theme.spacing(5)})`};
  margin: ${({ theme }) => `0 -${theme.spacing(2.5)}`};

  border-spacing: ${({ theme }) => `${theme.spacing(2.5)} ${theme.spacing(2)}`};
  border-collapse: separate;

  text-align: left;
`;

export const TableHeader = styled.thead`
  color: ${({ theme }) => theme.palette.grey[700]};
`;

export const TableRow = styled.tr``;

export const TableHeadCell = styled.th<{
  $isInteraction?: boolean;
  $alignRight?: boolean;
}>`
  padding: 0;
  width: ${({ $isInteraction }) => ($isInteraction ? '2.8rem' : 'auto')};

  ${({ $alignRight }) =>
    $alignRight &&
    css`
      text-align: right;
    `};
`;

export const TableBody = styled.tbody``;

export const TableCell = styled.td<{ $isInteraction?: boolean }>`
  padding: 0;
  width: auto;

  ${({ $isInteraction, theme }) =>
    $isInteraction &&
    css`
      width: 2.8rem;
      color: ${theme.palette.grey[700]};
    `};
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => theme.spacing(3)};

  border-top: 1px solid ${({ theme }) => theme.palette.grey[100]};
`;

export const Interactions = styled.div`
  flex: 1;
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: flex-end;
`;
